var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.2 10.95 10.55 6.3q.35-.15.712-.225A3.6 3.6 0 0 1 12 6q1.475 0 2.488 1.013T15.5 9.5a3.6 3.6 0 0 1-.3 1.45M5.85 17.1q1.275-.975 2.85-1.538A9.7 9.7 0 0 1 12 15q.45 0 .863.037.412.038.862.113l-2.2-2.2a3.38 3.38 0 0 1-2.013-.987 3.38 3.38 0 0 1-.987-2.013L5.675 7.1A7.855 7.855 0 0 0 4 12q0 1.474.487 2.775.488 1.3 1.363 2.325m12.45-.2a8.2 8.2 0 0 0 1.25-2.262Q20 13.4 20 12q0-3.325-2.337-5.662Q15.325 4 12 4q-1.4 0-2.637.45T7.1 5.7zM12 22a9.7 9.7 0 0 1-3.875-.788 10.1 10.1 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.187A9.7 9.7 0 0 1 2 12q0-2.075.788-3.887a10.2 10.2 0 0 1 2.15-3.175 10.1 10.1 0 0 1 3.187-2.15A9.7 9.7 0 0 1 12 2q2.076 0 3.887.788a10.2 10.2 0 0 1 3.175 2.15 10.2 10.2 0 0 1 2.15 3.175A9.65 9.65 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.875 10.1 10.1 0 0 1-2.15 3.188 10.2 10.2 0 0 1-3.175 2.15A9.65 9.65 0 0 1 12 22m0-2q1.325 0 2.5-.387a7.5 7.5 0 0 0 2.15-1.113 7.5 7.5 0 0 0-2.15-1.113A8 8 0 0 0 12 17q-1.325 0-2.5.387A7.5 7.5 0 0 0 7.35 18.5a7.5 7.5 0 0 0 2.15 1.113A8 8 0 0 0 12 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccounts);
export default __webpack_public_path__ + "static/media/no_accounts.311ddba9bfb0449ab3346ed451aee8a1.svg";
export { ForwardRef as ReactComponent };